/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".ms-NavExample-LeftPane{width:208px;height:500px;box-sizing:border-box;border:1px solid #eee;overflow-y:auto}"}]);
/* tslint:enable */